const pixelMap = [
    {
        title: 'Pixel Info',
        perRow: 3,
        arr: [
            {
                key: 'pixelName',
                type: 'text',
                val: '',
                label: 'Pixel Name',
                required: true,
                fullWidth: false
            },
            {
                key: 'pixelKey',
                type: 'text',
                val: '',
                label: 'Pixel Key',
                required: true,
                fullWidth: false
            },
            {
                key: 'httpMethod',
                type: 'autoComplete',
                val: 'allPixelHttpMethods',
                label: 'HTTP Method',
                returnKey: 'name',
                displayKey: 'name',
                required: true,
                fullWidth: false
            },
            {
                key: 'url',
                type: 'text',
                val: '',
                label: 'Base URL',
                required: true,
                fullWidth: false
            },
        ]
    },
];

const pixelQueryParametersMap = [
    {
        key: 'parameterName',
        type: 'text',
        val: '',
        label: 'Parameter Name',
        required: true,
        fullWidth: false
    },
    {
        key: 'sourceData',
        type: 'autoComplete',
        val: 'allPixelQueryParameterSourceData',
        label: 'Source Data',
        returnKey: 'name',
        displayKey: 'name',
        required: true,
        fullWidth: false
    },
    {
        key: 'constantValue',
        type: 'text',
        val: '',
        label: 'Constant Value',
        required: false,
        fullWidth: false
    },
];

const pixelSubscribersMap = [
    {
        key: 'affiliateId',
        label: "Affiliate Name & Id",
        type: 'autoCompleteNameWithId',
        val: "allAffiliate",
        returnKey: 'id',
        displayKey: 'name',
        required: false
    },
    {
        key: 'trafficSourceId',
        label: "Traffic Source Name & Id",
        type: 'autoCompleteNameWithId',
        val: "allTrafficSource",
        returnKey: 'id',
        displayKey: 'name',
        required: false
    },
    {
        key: 'revenueType',
        label: 'Type',
        type: 'autoComplete',
        val: "allRevenueTypes",
        returnKey: 'name',
        displayKey: 'name',
        required: true
    },
];

export { pixelMap, pixelQueryParametersMap, pixelSubscribersMap };